import { LoginModal } from '@digital-retail/falabella-ui-cross-components';
import { WarrantyModal } from '@digital-retail/warranty-library';
import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';
import { withApplicationContext } from '../../utils/ApplicationContext';
import { withCart } from '../../utils/CartContext';
import _ from '../../utils/LodashImports';
import { withProduct } from '../../utils/ProductContext';
import { withUser } from '../../utils/UserContext';
import { isWindow } from '../../utils/deviceChecker';
import { noop } from '../../utils/noop';
import Drawer from '../ui/Drawer/Drawer';
import MatchMedia from '../ui/MatchMedia/MatchMedia';
import { Modal } from '../ui/Modal/Modal';
import { getWarrantyBenefits } from '../ui/WarrantySelect/WarrantySelect.helpers';
import { trackWarrantySelection } from './Cart.Utils';
import CartDesktop from './CartDesktop/CartDesktop';
import CartMobile from './CartMobile/CartMobile';
import SelectVariant from './SelectVariant/SelectVariant';

const CartSection = ({ setBusy, cart, hasCrossSelling, setCrossSelling }) => (
  <MatchMedia
    content={{
      desktop: () => (
        <CartDesktop
          cart={cart}
          setBusy={setBusy}
          hasCrossSelling={hasCrossSelling}
          setCrossSelling={setCrossSelling}
        />
      ),
      mobile: () => (
        <CartMobile cart={cart} setBusy={setBusy} hasCrossSelling={hasCrossSelling} setCrossSelling={setCrossSelling} />
      ),
      tablet: () => (
        <CartMobile cart={cart} setBusy={setBusy} hasCrossSelling={hasCrossSelling} setCrossSelling={setCrossSelling} />
      ),
    }}
  />
);

CartSection.propTypes = {
  setBusy: PropTypes.func.isRequired,
  cart: PropTypes.object.isRequired,
  hasCrossSelling: PropTypes.bool.isRequired,
  setCrossSelling: PropTypes.func.isRequired,
};

const Cart = ({ cart, appCtx, product, refreshUserData }) => {
  const { deviceType } = appCtx;
  const { totalProductsCount, isVariantSelectionVisible } = cart;

  const { attributes, bundles } = product;

  const [hasCrossSelling, setCrossSelling] = useState(bundles?.length > 0 || attributes?.viewTemplate === 'TYPE_A');
  const isCartModalVisible = cart.showCart && !cart.showExtendedWarrantyModal;
  const atgBaseUrl = _.get(appCtx, 'siteConfig.endpoints.ATG_AUTH_BASEURL', 'https://www.falabella.com');
  const catalystBaseUrl = _.get(appCtx, 'siteConfig.endpoints.CATALYST_AUTH_BASEURL', 'https://www.falabella.com');
  const [warrantyBenefits, setWarrantyBenefits] = useState([]);

  useEffect(() => {
    const gCategoryId = _.get(product, 'attributes.GSCCategoryId', '');
    const regionCode = appCtx?.regionCode || 'cl';

    const benefits = getWarrantyBenefits({
      siteConfig: appCtx?.siteConfig,
      regionCode,
      gCategoryId,
    });

    setWarrantyBenefits(benefits);
  }, [product, appCtx]);
  const benefitsLabels = {
    WARRANTY_BENEFITS_LABEL: _.get(
      appCtx,
      'siteConfig.textDictionary.WARRANTY_BENEFITS_LABEL',
      'Beneficios de extender la garantía'
    ),
    MORE_WARRANTY_BENEFITS: _.get(appCtx, 'siteConfig.textDictionary.MORE_WARRANTY_BENEFITS', 'Más beneficios'),
    RECOMMENDED_WARRANTY: _.get(appCtx, 'siteConfig.textDictionary.RECOMMENDED_WARRANTY', '¡Recomendado!'),
    PDP_NO_THANKS: _.get(appCtx, 'siteConfig.textDictionary.PDP_NO_THANKS', 'Sin garantía extendida'),
    WARRANTY_ADDED: _.get(appCtx, 'siteConfig.textDictionary.WARRANTY_ADDED', 'Agregado'),
    WARRANTY_LABEL_TEMPLATE: _.get(appCtx, 'siteConfig.textDictionary.WARRANTY_LABEL_TEMPLATE', '{warrantyName}'),
    EXTENDED_WARRANTY_TITLE: _.get(appCtx, 'siteConfig.textDictionary.EXTENDED_WARRANTY_TITLE', 'Protege tu producto'),
  };

  const toggleLoginForm = () => {
    cart.setShowLoginForm(!cart.showLoginForm);
  };
  const onClose = () => {
    toggleLoginForm();
  };
  const onUserLogin = () => {
    refreshUserData();
  };

  const currentScreenHeight = isWindow() ? window.innerHeight : 0;
  const warrantyHeightStyle = currentScreenHeight <= 768 ? '100vh' : '100%';
  const height = product.warrantyOptions ? warrantyHeightStyle : 575;
  const cartModalHeight = hasCrossSelling ? height : 330;

  const modalContent = (actions) => {
    const { setBusy } = actions;
    return isVariantSelectionVisible ? (
      <SelectVariant cart={cart} appCtx={appCtx} />
    ) : (
      <CartSection setBusy={setBusy} cart={cart} hasCrossSelling={hasCrossSelling} setCrossSelling={setCrossSelling} />
    );
  };

  const drawerContent = (actions) => {
    const { setBusy } = actions;
    return isVariantSelectionVisible ? (
      <SelectVariant cart={cart} appCtx={appCtx} />
    ) : (
      <CartSection setBusy={setBusy} cart={cart} hasCrossSelling={hasCrossSelling} setCrossSelling={setCrossSelling} />
    );
  };

  useEffect(() => {
    if (typeof totalProductsCount !== 'undefined') {
      appCtx.changeCartCount(totalProductsCount);
    }
  }, [totalProductsCount]);

  const modalHeight = isVariantSelectionVisible ? 490 : cartModalHeight;
  const handleWarrantySelection = (warrantyOption) => {
    cart.setShowExtendedWarrantyModal(false);

    if (warrantyOption) {
      const warrantyWithSelected = { ...warrantyOption, selected: true };
      cart.setWarrantyOptionCurrent(warrantyWithSelected);
      trackWarrantySelection(
        'ModalA2C',
        _.get(cart, 'pendingProductData.product.currentVariant', '') || _.get(product, 'currentVariant', ''),
        warrantyWithSelected.name,
        warrantyWithSelected.value || warrantyWithSelected.variantId || warrantyWithSelected.id
      );

      if (cart.pendingProductData) {
        const warrantySkuId = warrantyOption.value || warrantyOption.variantId;
        const warrantyOfferingId = warrantyOption.offeringId;
        const modifiedData = {
          ...cart.pendingProductData,
        };
        if (modifiedData.products && modifiedData.products.length > 0) {
          modifiedData.products = modifiedData.products.map((prod) => ({
            ...prod,
            warrantySkuId,
            warrantyOfferingId,
          }));
        } else if (modifiedData.product) {
          modifiedData.product = {
            ...modifiedData.product,
            warrantySkuId,
            warrantyOfferingId,
            selectedWarranty: warrantyWithSelected,
          };

          // If product has serviceOptions, ensure they're added to products array
          if (modifiedData.product.serviceOptions && modifiedData.product.serviceOptions.length > 0) {
            if (!modifiedData.products) {
              modifiedData.products = [];
            }
            // Reconstruct products array with warranty and service options
            const productForArray = {
              skuId: modifiedData.product.skuId || modifiedData.product.currentVariant,
              productId: modifiedData.product.id || modifiedData.product.productId,
              quantity: modifiedData.product.quantity || 1,
              offeringId: modifiedData.product.offeringId,
              warrantySkuId,
              warrantyOfferingId,
              serviceOptions: modifiedData.product.serviceOptions,
            };
            modifiedData.products = [productForArray];
          }
        }
        cart
          .originalAddProduct(modifiedData)
          .then(() => {
            cart.setPendingProductData(null);
          })
          .catch(() => {
            cart.setPendingProductData(null);
          });
      }
    } else if (cart.pendingProductData) {
      const productSku =
        _.get(cart, 'pendingProductData.product.currentVariant', '') ||
        _.get(product, 'currentVariant', '') ||
        _.get(product, 'skuId', '');

      trackWarrantySelection('ModalA2C', productSku, 'Continuar sin protección', '');

      cart
        .originalAddProduct(cart.pendingProductData)
        .then(() => {
          cart.setPendingProductData(null);
        })
        .catch(() => {
          cart.setPendingProductData(null);
        });
    }
  };
  return (
    <>
      <WarrantyModal
        appCtx={appCtx}
        options={product.warrantyOptions?.fieldOptions || []}
        showModal={cart.showExtendedWarrantyModal}
        setShowModal={(show) => {
          if (!show) {
            cart.setShowExtendedWarrantyModal(false);
            if (cart.pendingProductData) {
              cart.setPendingProductData(null);
            }
          } else {
            cart.setShowExtendedWarrantyModal(show);
          }
        }}
        handleWarrantyChange={handleWarrantySelection}
        product={cart.pendingProductData?.product || product}
        isExtendedWarranty
        modalComponent={Modal}
        drawerComponent={Drawer}
        warrantyBenefits={warrantyBenefits}
        benefitsLabels={benefitsLabels}
      />

      {deviceType === 'desktop' && (
        <Modal
          showCloseButton={false}
          toggleState={{ setVisible: cart.setShowCart, visible: isCartModalVisible }}
          content={modalContent}
          withPadding={false}
          fullScreen={false}
          options={{
            disableOutsideClick: true,
            width: 800,
            height: modalHeight,
            overflow: 'hidden',
          }}
          deviceType={deviceType}
        />
      )}
      {deviceType !== 'desktop' && (
        <Drawer
          toggleState={[isCartModalVisible, cart.setShowCart]}
          isLoading={false}
          type="secondary"
          icon=""
          heading=""
          disableOutsideClick
          disableDrawerClose={false}
          hideDivider
          autoHeight
          hideCloseButton={false}
          enableAdobeCarousel={!isVariantSelectionVisible}
        >
          {drawerContent({ setBusy: () => {} })}
        </Drawer>
      )}

      <LoginModal
        id="testId-atc-cart"
        isRebrandingEnabled
        atgBaseUrl={atgBaseUrl}
        catalystBaseUrl={catalystBaseUrl}
        onClose={onClose}
        onUserLogin={onUserLogin}
        tenant={appCtx.regionCode}
        showLoginForm={cart.showLoginForm}
      />
    </>
  );
};

Cart.defaultProps = {
  refreshUserData: noop,
};
Cart.propTypes = {
  cart: PropTypes.object.isRequired,
  appCtx: PropTypes.object.isRequired,
  product: PropTypes.object.isRequired,
  refreshUserData: PropTypes.func,
};

export default withApplicationContext(withProduct(withCart(withUser(Cart))));
export { Cart, CartSection };
